import { Component, ElementRef, Input, OnChanges } from '@angular/core';
import { LocalisationService } from '@app/services/localisation.service';

@Component({
  selector: 'read-more',
  templateUrl: './read-more.component.html',
  styleUrls: ['./read-more.component.scss']
})
export class ReadMoreComponent implements OnChanges {
  @Input()
  text: string;
  @Input()
  maxLength: number = 100;
  @Input()
  moreLabel: string;
  @Input()
  hideLabel: string;

  locale: any = {};
  currentText: string;
  hideToggle: boolean = true;

  public isCollapsed: boolean = true;

  constructor(private elementRef: ElementRef, private localisation: LocalisationService) {}

  ngOnInit() {
    this.locale = this.localisation.getTranslationsForComponent('ReadMoreComponent');

    if (typeof this.moreLabel == 'undefined') {
      this.moreLabel = this.locale.showLabel;
    }

    if (typeof this.hideLabel == 'undefined') {
      this.hideLabel = this.locale.hideLabel;
    }
  }

  toggleView() {
    this.isCollapsed = !this.isCollapsed;
    this.determineView();
  }

  determineView() {
    if (this.text.length <= this.maxLength) {
      this.currentText = this.text;
      this.isCollapsed = false;
      this.hideToggle = true;
      return;
    }
    this.hideToggle = false;
    if (this.isCollapsed == true) {
      this.currentText = this.text.substring(0, this.maxLength);
      this.currentText = this.currentText.substr(
        0,
        Math.min(this.currentText.length, this.currentText.lastIndexOf(' '))
      );
      this.currentText = this.currentText + '...';
    } else if (this.isCollapsed == false) {
      this.currentText = this.text;
    }
  }

  ngOnChanges() {
    this.determineView();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/read-more/read-more.component.ts